import eliteService from './../api/elite-service';
import redirect from '../uitls/redirect';
import { notifyError } from '../uitls/notification-helper';
import { MESSAGES } from '../uitls/messages';
import retry from '@/utils/retry';

const state = {
    videos: [],
    summary: { avgAccuracy: 0, totalCalories: 0, workoutTime: 0 },
    displayVideosCount: 4,
    startIndex: -4,
    videoToDisplay: null,
    hideNextButton: false,
    hidePrevButton: false,
    workoutData: null,
    workoutGraphData:[],
    coorparateData:[],
    otheGraphData:[],
    isFramesCountLoading: true,
    capturedframesCount: null,
    expectedFramesCount: null,
    tenantId: null
};

const mutations = {
    setVideos(state, videos) {
        state.videos = videos;
    },

    setSummary(state, { summary, workoutData }) {
        summary.avgAccuracy =
          summary.avgAccuracy && !isNaN(summary.avgAccuracy)
            ? Math.round(summary.avgAccuracy)
            : 0;
        summary.totalCalories =
          summary.totalCalories && !isNaN(summary.totalCalories)
            ? Math.round(summary.totalCalories)
            : 0;
        summary.workoutTime =
          summary.workoutTime && !isNaN(summary.workoutTime)
            ? Math.round(parseFloat(summary.workoutTime))
            : 0;
        summary.rowCount =
          summary.rowCount && !isNaN(summary.rowCount)
            ? parseInt(summary.rowCount)
            : 0;

        summary.avgAccuracy =
              summary.rowCount != 0 ? summary.avgAccuracy / summary.rowCount : 0;

        state.summary = summary;
    },

    setGraphData(state, data){
        state.workoutGraphData = data;
    },

    setCoorparateData(state, data){
        state.coorparateData = data;
    },

    setOtherUserGraphData(state, data){
        state.otheGraphData = data;
    },

    setWorkoutData(state, data) {
        state.workoutData = data;
        localStorage.setItem('workoutData', JSON.stringify(data));
    },

    setFramesCount(state, data) {
        state.capturedframesCount = data.capturedCount;
        state.expectedFramesCount = data.expectedCount;
    },

    setIndex(state, dir) {
        state.hidePrevButton = false;
        state.hideNextButton = false;
        state.startIndex = (dir == "prev") ? state.startIndex - state.displayVideosCount : state.startIndex + state.displayVideosCount;
        let videos = state.videos;
        if (videos.length < 4) {
            state.videoToDisplay = videos;
            state.hidePrevButton = true;
            state.hideNextButton = true;
            return;
        }

        if (state.startIndex + state.displayVideosCount > videos.length) {
            state.startIndex = videos.length - state.startIndex;
        }
        if (state.startIndex < 1) {
            state.startIndex = 0;
            state.hidePrevButton = true;
        }
        if (state.startIndex > -1) {
            state.videoToDisplay = videos.splice(state.startIndex, state.displayVideosCount);
        }
        if (state.startIndex >= state.videos.length) {
            state.hideNextButton = true;
        }
    },

    setFramesCountLoading(state, value) {
        state.isFramesCountLoading = value;
    }
};

const getters = {
    videoList(state) {
        return state.videoToDisplay;
    },
    videoListMobile(state){
        let videosMobile = state.videos;
        videosMobile = videosMobile.length > 6 ? videosMobile.splice(0, 6) : videosMobile;
        return videosMobile;
    }
};

const actions = {
    async loadVideos({ commit }) {
        try {
            const videos = await eliteService.getAllVideosOfTenant(state.workoutData.videoId);
            commit('setVideos', videos);
            return videos;
        } catch (e) {
            retry(e).then(async _ => {
                const videos = await eliteService.getAllVideosOfTenant(state.workoutData.videoId);
                commit('setVideos', videos);
                return videos;
            }).catch(e => {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            });
        }
    },

    async loadTenantVideos({ commit }, tenantId) {
        try {
            let videos = await eliteService.getAllVideos();
            videos = videos.filter(video => video.tenantId === tenantId)
            commit('setVideos', videos);
            return videos;
        } catch (e) {
            retry(e).then(async _ => {
                let videos = await eliteService.getAllVideos();
                videos = videos.filter(video => video.tenantId === tenantId)
                commit('setVideos', videos);
                return videos;
            }).catch(e => {
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            });
        }
    },

    async loadUserWorkoutSummary({ commit }, workoutData) {
        try {
            const summary = await eliteService.getWorkoutSummary();
            commit('setSummary', { summary, workoutData });
            return summary;
        } catch (e) {
            retry(e).then(async _ => {
                const summary = await eliteService.getWorkoutSummary();
                commit('setSummary', { summary, workoutData });
                return summary;
            }).catch(e => {
                redirect(e);
                Promise.reject(e);
            });
        }
    },

    async loadUserGraphDetails({ commit }, obj) {
        try {
            const summary = await eliteService.getWorkoutGraphSummary(obj);
            commit('setGraphData', summary );
            return summary;
        } catch (e) {
            retry(e).then(async _ => {
                const summary = await eliteService.getWorkoutGraphSummary(obj);
                commit('setGraphData', summary );
                return summary;
            }).catch(e => {
                redirect(e);
                Promise.reject(e);
            });
        }
    },

    async loadCooparateUserDetails({ commit }, userId) {
        try {
            const summary = await eliteService.getCooparateUserDetails(userId);
            commit('setCoorparateData', summary );
            return summary;
        } catch (e) {
            retry(e).then(async _ => {
                const summary = await eliteService.getCooparateUserDetails(userId);
                commit('setCoorparateData', summary );
                return summary;
            }).catch(e => {
                redirect(e);
                Promise.reject(e);
            });
        }
    },

    async loadOtherUserGraphDetails({ commit }, obj) {
        try {
            const summary = await eliteService.getOtherUserGraphDetails(obj);
            commit('setOtherUserGraphData', summary );
            return summary;
        } catch (e) {
            retry(e).then(async _ => {
                const summary = await eliteService.getOtherUserGraphDetails(obj);
                commit('setOtherUserGraphData', summary );
                return summary;
            }).catch(e => {
                redirect(e);
                Promise.reject(e);
            });
        }
    },

    async loadFramesCount({ commit }, sessionId) {
        try {
            commit('setFramesCountLoading', true);
            const count = await eliteService.loadFramesCount(sessionId);
            commit('setFramesCount', count);
            commit('setFramesCountLoading', false);
            return count;
        } catch (e) {
            retry(e).then(async _ => {
                const count = await eliteService.loadFramesCount(sessionId);
                commit('setFramesCount', count);
                return count;
            }).catch(e => {
                redirect(e);
                Promise.reject(e);
            }).finally(() => {
                commit('setFramesCountLoading', false);
            });
        }
    },

    setIndex({ commit }, dir) {
        commit('setIndex', dir);
    }
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {

    }
}
